import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'constants/RoutePaths';
import { buildRoutePath } from 'utils/utility';
import { useGetTrailListQuery } from 'app/api/trailApiSlice';
import MLTable from 'components/common/Table/Table';
import { MLSearchInput } from 'components/common/SearchInput/SearchInput';

const TrailHome = () => {
  const navigate = useNavigate();
  const { data: trails = [], isLoading, error } = useGetTrailListQuery();
  const [search, setSearch] = useState(null);
  const [filteredRows, setFilteredRows] = useState(null);
  const [tableRows, setTableRows] = useState([]);

  useEffect(() => {
    if (trails) {
      const rows = trails.map((trail) => ({
        id: trail.trailid,
        parkname: trail.parkname,
        trailname: trail.trailname,
        rowClickVars: {
          id: trail.trailid,
        },
      }));
      setTableRows(rows);
      if (!search) {
        setFilteredRows([...(rows ?? [])]);
      } else {
        const filteredData = rows.filter((trail) => {
          if (!search) return true;
          if (search.length === 1) {
            return trail.trailname
              ?.toLowerCase()
              .startsWith(search.toLowerCase());
          }
          if (search.length > 1) {
            const s = search.toLowerCase();
            return (
              trail.trailname?.toLowerCase().includes(s) ||
              trail.parkname?.toLowerCase().includes(s)
            );
          }
          return true;
        });
        setFilteredRows([...(filteredData ?? [])]);
      }
    }
  }, [trails, search]);

  const goToTrail = (vars) => {
    const { id } = vars;
    navigate(
      `/${buildRoutePath(ROUTES.TRAIL_DETAIL, {
        trailId: id,
      })}`
    );
  };

  let columns = [
    {
      id: 'trailname',
      label: 'Trail',
      minWidth: 50,
    },
  ];

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading trails.</div>;

  return (
    <div style={{ padding: 12 }}>
      <div className="flex items-center gap-6 pb-2">
        <MLSearchInput
          placeholderText="Search trails"
          setSearchChange={setSearch}
          searchValue={search}
        />
      </div>

      <div className="h-full max-h-[calc(100%_-_69px)] bg-[var(--ts-surface)] rounded-2xl">
        <MLTable
          columns={columns}
          rows={filteredRows}
          isDataLoading={isLoading}
          noDataFoundMsg="No trails found."
          isRowClickable={true}
          rowHandler={goToTrail}
        />
      </div>
      {filteredRows?.length === 0 && <div>No trails found.</div>}
    </div>
  );
};

export default TrailHome;
